export const CLOSE_MODAL = 'CLOSE_MODAL';
export type CLOSE_MODAL = typeof CLOSE_MODAL;



// WEBPACK FOOTER //
// ./src/actions/modal/close/Types.tsx